import React, { Component } from 'react'

import EditableLabel from '../common/EditableLabel'
import ElementContainer from '../common/ElementContainer'
import { faPen } from '@fortawesome/free-solid-svg-icons'

import './Description.css'

export default class Description extends Component {
  static weight = 14

  static defaultConfig = {
    id: 0,
    type: 'Description',
    label: '',
    sublabel: ''
  }

  static metaData = {
    icon: faPen,
    displayText: 'Description',
    group: 'pageElement'
  }

  static configurableSettings = {
    alignment: {
      default: 'Center',
      formProps: {
        type: 'Radio',
        options: ['Center', 'Left', 'Right'],
        label: 'Header alignment'
      }
    },
    fontSize: {
      default: '14',
      formProps: {
        type: 'Number',
        label: 'Font Size'
      }
    },
    fontColor: {
      default: '#000000',
      formProps: {
        type: 'TextBox',
        label: 'Font Color'
      }
    }
  }

  render() {
    const { config, mode } = this.props
    const inputProps = {}
    const alignmentClassName = `align${config.alignment}`

    if (typeof config.value !== 'undefined') {
      inputProps.value = config.value
    }

    if (typeof this.props.onChange !== 'undefined') {
      inputProps.onChange = this.props.onChange
    }

    return (
      <ElementContainer type={config.type} {...this.props}>
        <div
          style={{
            fontSize: `${config.fontSize || 16}px`,
            color: config.fontColor || '#000'
          }}>
          <EditableLabel
            className={alignmentClassName}
            mode={mode}
            labelKey={config.id}
            handleLabelChange={this.props.handleLabelChange}
            value={config.label}
            dataPlaceholder="Type a description"
          />
        </div>
      </ElementContainer>
    )
  }
}
